export const isInRange = (num: number, start: number, end: number) =>
    start <= num && num <= end;

export const getFormattedPrice = (price: number, currency: string = "EUR") =>
    price.toLocaleString(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });